var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-verify-cell-phone-1',{staticClass:"my-5",attrs:{"image":require('@/assets/user-login-svgrepo-com.svg')}})}
var staticRenderFns = []

export { render, staticRenderFns }